import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { ProgressBar } from 'primereact/progressbar';
import Container from 'react-bootstrap/Container';
import { useAuth } from '../contexts/AuthContext';
import { canAccessNotificationSettings, canAccessSupportSettings, canAccessTileTimeLimitation } from '../utils/accessControl';
import AccessState from './AccessState';

const SupportSettings = () => {
	const navigate = useNavigate();
	const { accessContext, isAuthReady } = useAuth();
	const canManageNotificationSettings = canAccessNotificationSettings(accessContext);
	const canManageTileTimeLimitation = canAccessTileTimeLimitation(accessContext);
	const hasSettingsAccess = canAccessSupportSettings(accessContext);

	if (!isAuthReady) {
		return (
			<Card className="justify-content-md-center mt-5">
				<Container fluid="md">
					<div className="card mt-3">
						<ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
					</div>
				</Container>
			</Card>
		);
	}

	return (
		<Card className="justify-content-md-center mt-5">
			<Container fluid="md">
				<div className="panel">
					<div className="flex align-content-center flex-wrap">
						<Button link icon="pi pi-arrow-left" onClick={() => navigate(-1)} className="flex mb-3" />
						<h4 className="flex mt-2 mb-3">Settings</h4>
					</div>
				</div>
				{hasSettingsAccess ? (
					<>
						{canManageNotificationSettings && (
							<Button
								label="Notification settings"
								icon="pi pi-bell"
								className="p-button-text"
								onClick={() => navigate('/support/notification-settings')}
							/>
						)}
						{canManageTileTimeLimitation && (
							<p className="mb-0 mt-3">Tile Time Limitation actions are enabled for this account.</p>
						)}
					</>
				) : (
					<AccessState
						title="Settings Unavailable"
						message="Your account does not currently have access to support settings."
						actionLabel="Go To Support Home"
						actionTo="/support"
						autoRedirectTo="/support"
						autoRedirectDelayMs={2500}
					/>
				)}
			</Container>
		</Card>
	);
};

export default SupportSettings;
